import { FileSystemRecord } from "./FileSystemRecord";
import { ImageFilesystem } from "./image_filesystem"
import { MediaImageType } from "./media_image_type"
import { MediaImageRepositoryPathAdapter } from "./MediaImageRepositoryPathAdapter";

export class MediaImageStore {
  protected filesystem: ImageFilesystem
  protected projectId: string;
  protected pathAdapater: MediaImageRepositoryPathAdapter;

  getProjectId(): string {
    return this.pathAdapater.adapt(this.projectId);
  }

  getPathForClearing(): string {
    return this.pathAdapater.adaptForClearing(this.projectId);
  }

  
  constructor(projectId: string, adapter: MediaImageRepositoryPathAdapter) {
    this.projectId = projectId;
    this.pathAdapater = adapter;
    
    this.filesystem = new ImageFilesystem(this.getProjectId())
  }

  public updateProjectId(id: string, adapter: MediaImageRepositoryPathAdapter)  {
    this.projectId = id;
    this.pathAdapater = adapter;
    this.filesystem.update(this.getProjectId())
  }

  async storeImageBlobString(
    layer: string,
    layerStateId: string,
    imageType: MediaImageType,
    imageBlobUrl: string,
  ): Promise<boolean> {    
    return this.filesystem.setImage(layer, layerStateId, imageType, imageBlobUrl)
  }

  async getImage(
    layer: string,
    layerStateId: string,
    imageType: MediaImageType
  ): Promise<string> {
    const record = await this.getRecord(layer, layerStateId, imageType)
    return record?.getBlobUrl()
  }

  async getRecord(
    layerId: string,
    layerStateId: string,
    imgType: MediaImageType
  ): Promise<FileSystemRecord | null> {
    const record = await this.filesystem.getRecord(layerId, layerStateId, imgType)
    return record
  }

  async hasRecord(layerId: string, layerStateId: string, imgType: MediaImageType): Promise<boolean> {
    const record = await this.filesystem.getRecord(layerId, layerStateId, imgType)
    return !!(record && await record.getBlobUrl())
  }

  async getImagePath(layer: string, layerStateId: string, imageType: MediaImageType): Promise<string> {
    return this.filesystem.getImagePath(layer, layerStateId, imageType)
  }

  async link(layer: string, layerStateId: string, srcImageType: MediaImageType, targetImageType: MediaImageType): Promise<void> {
    return this.filesystem.link(layer, layerStateId, srcImageType, targetImageType)
  }

  async restoreUndo(layer: string, layerStateId: string, imageType: MediaImageType) {
    await this.filesystem.restoreUndoDate(layer, layerStateId, imageType)
  }

  async removeImage(layer: string, layerStateId: string, imageType: MediaImageType) {
    this.filesystem.removeImage(layer, layerStateId, imageType)
  }

  async duplicate(originalLayerId: string, newLayerId: string, layerStateId: string) {
    await this.filesystem.duplicate(originalLayerId, newLayerId, layerStateId)
  }
}
